const questions = [
  {
    question: 'How many followers do you have? ',
    placeholder: 'e.g. 500,000',
  },
  {
    question: 'Have you tried our products? If so, which one is your favorite and why?',
    placeholder: 'Eg: You really loved one of our products and want to promote it',
  },
  {
    question: 'How do you intend to promote these products?',
    placeholder: 'Eg: Any creative ideas to promote our products to your audience?',
  },
];
const questionsToPlaceholderMap: Record<string, string> = {};
questions.forEach((question) => {
  questionsToPlaceholderMap[question.question] = question.placeholder;
});

const getPlaceholderForQuestion = (question: string) => {
  if (question.startsWith('Why do you want to become an ambassador for')) {
    return "'e.g. I love your brand and can help spread the word'";
  }
  if (questionsToPlaceholderMap[question]) {
    return questionsToPlaceholderMap[question];
  }

  return 'Your answer here';
};

export default getPlaceholderForQuestion;
